import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { ProtectedRoute } from 'src/routes/ProtectedRoute';

const Step1SelectAreas = lazy(() => import('src/pages/add-activity/Step1SelectAreas'));
const Step2ConfirmActivities = lazy(() => import('src/pages/add-activity/Step2ConfirmActivities'));
const Celebration = lazy(() => import('src/pages/add-activity/Celebration'));
const ActivityDetailPage = lazy(() => import('src/pages/activity-detail'));

function lazyRoute(element: React.ReactNode): React.ReactNode {
  return <Suspense fallback={null}>{element}</Suspense>;
}

// The whole add-activity wizard + activity detail page require an authenticated
// user (they read/write per-user records), so they sit behind ProtectedRoute.
export const activitiesRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      { path: '/add-activity', element: lazyRoute(<Step1SelectAreas />) },
      { path: '/add-activity/confirm', element: lazyRoute(<Step2ConfirmActivities />) },
      { path: '/add-activity/celebrate', element: lazyRoute(<Celebration />) },
      { path: '/activities/:id', element: lazyRoute(<ActivityDetailPage />) },
    ],
  },
];
